<template>
  <div>
    <table-card
      :items="inspections"
      sortBy="endTime" sortDir="desc"
      :fields="[ 'id', 'name', 'completed', 'expired', 'endTime', 'settings' ]"
      title="Inventory Inspections">

      <template v-slot:cell(id)="data">
        <b-badge>{{ data.value }}</b-badge>
      </template>
      <template v-slot:cell(completed)="data">
        <b-badge :variant="data.value ? 'success' : 'danger'">{{ data.value ? 'Yes' : 'No' }}</b-badge>
      </template>
      <template v-slot:cell(endTime)="data">
        {{ new Date(data.value).toLocaleString() }}
      </template>
      <template v-slot:cell(expired)="data">
        {{ data.item.endTime < (+new Date()) }}
      </template>
      <template v-slot:cell(settings)="data">
        <div class="hidden-button-group float-right">
          <icon-button :to="{ name: 'AdminInspection', params: { id: data.item.id }}" icon="icon-Settings"
                       variant="outline-border" tooltip="Settings"></icon-button>
          <icon-button :to="{ name: 'AdminInspectionResults', params: { id: data.item.id }}" icon="icon-Reports"
                       variant="outline-border" tooltip="Results"></icon-button>
        </div>
      </template>
    </table-card>

    <div class="row text-left">
      <div class="col-sm">
        <b-btn :disabled="!isSuperAdmin" type="button" :to="{ name: 'AdminInspection' }" variant="primary" class="my-3 mx-0">
          + New Inspection
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import TableCard from '@/components/TableCard'
  import { AdminApi } from '@/admin/api'
  import auth from "../../auth";

  export default {
      created () {
        AdminApi.inspectionsList().then((list) => {
            this.inspections = list != null ? list.reverse() : list
        })
      },
      data () {
          return {
              isSuperAdmin: auth.isSuperAdmin(),
              inspections: []
          }
      },
      components: {
          TableCard
      }
  }
</script>



// WEBPACK FOOTER //
// src/admin/pages/InspectionList.vue